export default "__VITE_ASSET__77c31295__"